import { render, staticRenderFns } from "./JournalSectionHeader.vue?vue&type=template&id=26fa8b16&scoped=true&"
import script from "./JournalSectionHeader.vue?vue&type=script&lang=js&"
export * from "./JournalSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./JournalSectionHeader.vue?vue&type=style&index=0&id=26fa8b16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fa8b16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDialog,VIcon,VTooltip})
